import { SearchProduct as ProtoSearchProduct } from '@italist/grpc-proto/entities/search_pb';
import { Product } from './product';

export type SearchResult = ProtoSearchProduct.AsObject & {
  url: string;
};

export const isSearchProduct = (product: Product | SearchResult): product is SearchResult => {
  return !!(product as SearchResult).brandId;
};
